import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { AlvaroC_Video2 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoAlvaro2 = () => {
  return (
    <>
      <ModalVideo
        id="alvaro-video-2"
        dataText={AlvaroC_Video2}
        videoSrc="https://www.youtube.com/embed/zs35Gxd6jPg?si=3MN2xA1d4XhD5T9t"
        videoTitle="KUTER_STUDIO_AI_ALVARO_VIDEO_2"
      />
    </>
  );
};

export default ModalVideoAlvaro2;
